export default "__VITE_ASSET__Cj2VBQZC__"